import { Button } from '@repo/shadcn';
import { FC } from 'react';
import { z } from 'zod';

import { IwForm } from '@components/form';
import { TextField } from '@components/form/fields';
import { SectionTitle } from '@components/ui';

const TypeFormSchema = z.object({
    name: z.string().min(1, 'Name is required'),
});

export type TTypeForm = z.infer<typeof TypeFormSchema>;

type TypeFormProps = {
    initialValues: TTypeForm;
    onSubmit?: (data: TTypeForm) => Promise<void>;
    isLoading?: boolean;
    title?: string;
};

export const TypeForm: FC<TypeFormProps> = ({
    initialValues,
    onSubmit,
    isLoading = false,
    title = 'Type Form',
}) => {
    return (
        <div>
            <SectionTitle>{title}</SectionTitle>
            <IwForm
                schema={TypeFormSchema}
                initialValues={initialValues}
                onSubmit={onSubmit as any}
            >
                <div className={'flex flex-col space-y-4'}>
                    <TextField<TTypeForm>
                        name={'name'}
                        label={'Name'}
                        placeholder={'Enter type name'}
                    />

                    <div className={''}>
                        <Button type={'submit'} disabled={isLoading}>
                            {isLoading ? 'Saving...' : 'Save Changes'}
                        </Button>
                    </div>
                </div>
            </IwForm>
        </div>
    );
};

TypeForm.displayName = 'TypeForm';
